import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import { Loading } from '../../components/Loading';
import { Table } from '../../components/tables/Table';
import { FiEdit, FiRefreshCcw, FiTrash2 } from 'react-icons/fi';
import { M_Brands } from './M_Brands';
import { activateBrand, deactivateBrand, loadBrands } from '../../app/store/catalogs/thunk';

export const Brands = ({ activeTab }) => {

  const { isLoading, catalog, catalogEdit, msg } = useSelector(state => state.catalogs);

  const dispatch = useDispatch();
  const [selectedItem, setSelectedItem] = useState(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (activeTab === "brands") {
      dispatch(loadBrands());
    }
  }, [activeTab])



  const handledDelete = (id) => {

    Swal.fire({
      title: 'Atención',
      text: "Está por desactivar una Marca, ¿Desea de continuar con esta acción?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3b7ddd',
      cancelButtonColor: '#dc3545',
      cancelButtonText: 'No',
      confirmButtonText: 'Si'
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(deactivateBrand(id));
      }
    })
  }

  const handledActive = (id) => {
    Swal.fire({
      title: 'Atención',
      text: "Está por activar una Marca, ¿Desea de continuar con esta acción?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3b7ddd',
      cancelButtonColor: '#dc3545',
      cancelButtonText: 'No',
      confirmButtonText: 'Si'
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(activateBrand(id));
      }
    })
  }

  let columns = [
    {
      header: 'ID',
      dataIndex: 'ID',
      classHeader: 'text-start',
      classRow: 'text-start',
    },
    {
      header: 'NOMBRE',
      dataIndex: 'NAMEBRAND',
      classHeader: 'text-start',
      classRow: 'text-start',
    },
    {
      header: 'DESCRIPCION',
      dataIndex: 'DESCRIPTIONS',
      classHeader: 'text-start',
      classRow: 'text-start',
    },
    {
      header: 'ESTADO',
      dataIndex: 'STATUSDESC',
      classHeader: 'text-start',
      classRow: 'text-start',

      renderer: (value, row) =>
        row.ACTIVE === "1" ? (
          <span className="badge text-bg-primary text-uppercase">{value}</span>
        ) : (
          <span className="badge text-bg-danger">ELIMINADO</span>
        )
      ,
    },
    {
      header: 'ACCIONES',
      dataIndex: 'ACTIVE',
      classHeader: 'text-center',
      classRow: 'text-center',
      renderer: (value, row) => (
        <div className="btn-group border-0" role="group">
          <button
            type="button"
            className="btn btn-outline-primary border-0"
            onClick={() => {
              setSelectedItem(row);
              setShowModal(true);
            }}
          >
            <FiEdit size={20} />
          </button>
          {row.ACTIVE === "1" ? (
            <button
              type="button"
              className="btn btn-outline-danger border-0"
              onClick={() => handledDelete(row.ID)}
            >
              <FiTrash2 size={20} />
            </button>
          ) : (
            <button
              type="button"
              className="btn btn-outline-success border-0"
              onClick={() => handledActive(row.ID)}
            >
              <FiRefreshCcw size={20} />
            </button>
          )}
        </div>
      )
    }
  ];

  const data = [...catalog];



  return (
    <>
      {showModal && (
        <M_Brands
          selectedItem={selectedItem}
          setSelectedItem={setSelectedItem}
          onClose={() => setShowModal(false)}
        />
      )}
      <div className="card">
        <div className="card-header border-bottom">
          <h5 className="card-title mb-0 fw-bold text-black">Marcas</h5>
        </div>
        <div className="card-body row" style={{ height: 'calc(90% - 56px)', overflowY: 'auto' }} >

          <div className='col-12'>
            <button type="button" className="btn btn-outline-primary" onClick={() => { setSelectedItem(null); setShowModal(true); }} >
              Agregar nueva marca
            </button>
          </div>
          <div className='col-12 mt-3'>
            {
              (isLoading) ? <Loading /> :
                <Table columns={columns} data={data} function_={[]} placeholderSearch="Buscar marca" showPagination={true} showControls={true} showTotals={false} />
            }
          </div>
        </div>
      </div>
    </>
  )
}
